import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../config-global';
// ---------------------------------------------------------------------------------------------------

const SPACING = 4;

Main.propTypes = {
    sx: PropTypes.object,
    children: PropTypes.node,
};

export default function Main({ children, sx, ...other }) {

    const { pathname } = useLocation();
    const isDesktop = useResponsive('up', 'lg');

    const [headerHeight, setHeaderheight] = useState(HEADER.H_DASHBOARD_DESKTOP);

    useEffect(() => {
        if (pathname.split('/')[2] === "data") {
            setHeaderheight(HEADER.H_DATA);
        }
        else {
            setHeaderheight(HEADER.H_DASHBOARD_DESKTOP);
        }
    }, [pathname]);

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                pt: `${HEADER.H_MOBILE + SPACING}px`,
                ...(isDesktop && {
                    px: 2,
                    pt: `${headerHeight + SPACING}px`,
                    width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
                }),
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    );
}
